import io from 'socket.io-client';
import server from './server';

const socket = io(`${server}`);

export default socket;
